
import { axios } from '@/utils/request'

const api = {
  options: '/adminapi/jiandu/options',
  jianduManageList: '/adminapi/jiandu/jianduManageList',
  manageDetail: '/adminapi/jiandu/manageDetail',
  editManage: '/adminapi/jiandu/editManage',
  memberList: '/adminapi/jiandu/memberList',
  memberDetail: '/adminapi/jiandu/memberDetail',
  memberEdit: '/adminapi/jiandu/memberEdit',
  manageDelete: '/adminapi/jiandu/manageDelete',
  memberDelete: '/adminapi/jiandu/memberDelete',
  memberImport: '/adminapi/jiandu/memberImport',
  shenheUrls: '/adminapi/jiandu/shenheUrls',
}

export default api

export function getOptions(parameter) {
  return axios({
    url: api.options,
    method: 'get',
    params: parameter
  })
}

export function jianduManageList(parameter) {
  return axios({
    url: api.jianduManageList,
    method: 'get',
    params: parameter
  })
}
export function manageDetail(parameter) {
  return axios({
    url: api.manageDetail,
    method: 'get',
    params: parameter
  })
}

export function editManage(parameter) {
  return axios({
    url: api.editManage,
    method: 'post',
    data: parameter
  })
}

export function getApplyMemberList(parameter) {
  return axios({
    url: api.memberList,
    method: 'post',
    data: parameter
  })
}
export function memberEdit(parameter) {
  return axios({
    url: api.memberEdit,
    method: 'post',
    data: parameter
  })
}

export function memberDetail(parameter) {
  return axios({
    url: api.memberDetail,
    method: 'get',
    params: parameter
  })
}

export function applyDelete(parameter) {
  return axios({
    url: api.manageDelete,
    method: 'get',
    params: parameter
  })
}

export function memberDelete(parameter) {
  return axios({
    url: api.memberDelete,
    method: 'get',
    params: parameter
  })
}
export function memberImport(parameter) {
  return axios({
    url: api.memberImport,
    method: 'post',
    data: parameter
  })
}

export function getShenheUrls(parameter) {
  return axios({
    url: api.shenheUrls,
    method: 'get',
    params: parameter
  })
}
